export default __webpack_public_path__ + "static/media/easy_donors_icon.fc76de8b.png";